import { useEffect, useRef } from 'react';

const SCALAR_CDN = 'https://cdn.jsdelivr.net/npm/@scalar/api-reference@1.49.7';

function buildIframeHtml(specUrl: string): string {
  // Use single-quoted attribute so the JSON double-quotes don't need escaping.
  const config = JSON.stringify({ spec: { url: specUrl } });
  return `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <style>html, body { margin: 0; }</style>
</head>
<body>
  <script id="api-reference" data-configuration='${config}'></script>
  <script src="${SCALAR_CDN}"></script>
</body>
</html>`;
}

interface Props {
  specUrl: string;
}

export default function ScalarViewer({ specUrl }: Props) {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    // srcdoc iframes share the parent's origin, so absolute URLs resolve
    // correctly and same-origin fetches work without CORS headers.
    const absoluteSpecUrl = specUrl.startsWith('http')
      ? specUrl
      : `${window.location.origin}${specUrl}`;

    if (iframeRef.current) {
      iframeRef.current.srcdoc = buildIframeHtml(absoluteSpecUrl);
    }
  }, [specUrl]);

  return (
    <iframe
      ref={iframeRef}
      style={{ width: '100%', flex: 1, border: 'none', display: 'block' }}
      title="API Reference"
    />
  );
}
